import { render } from "./projectsChart.vue?vue&type=template&id=6c3ca318"
import script from "./projectsChart.vue?vue&type=script&lang=js"
export * from "./projectsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__